import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import CategoryManage from '../views/CategoryManage.vue'
import VideoManage from '../views/VideoManage.vue'
import QuizManage from '../views/QuizManage.vue'
import UserManage from '../views/UserManage.vue'
import InspectManage from '../views/InspectManage.vue'
import StudyRecords from '../views/StudyRecords.vue'
import CheckinManage from '../views/CheckinManage.vue'
import Layout from '../components/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false, title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    meta: { requiresAuth: true, title: '首页' },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '仪表盘' }
      },
      {
        path: 'category-manage',
        name: 'CategoryManage',
        component: CategoryManage,
        meta: { title: '栏目管理' }
      },
      {
        path: 'video-manage',
        name: 'VideoManage',
        component: VideoManage,
        meta: { title: '视频管理' }
      },
      {
        path: 'quiz-manage',
        name: 'QuizManage',
        component: QuizManage,
        meta: { title: '测验管理' }
      },
      {
        path: 'user-manage',
        name: 'UserManage',
        component: UserManage,
        meta: { title: '用户管理' }
      },
      {
        path: 'inspect-manage',
        name: 'InspectManage',
        component: InspectManage,
        meta: { title: '隐患排查' }
      },
      {
        path: 'study-records',
        name: 'StudyRecords',
        component: StudyRecords,
        meta: { title: '学习记录' }
      },
      {
        path: 'checkin-manage',
        name: 'CheckinManage',
        component: CheckinManage,
        meta: { title: '签到记录' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, _from, next) => {
  const isAuthenticated = localStorage.getItem('admin-token') // 模拟登录状态
  if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router